import { RESOURCES } from '@shared/Resources/types';

export const getSmartPracticeDisabledReasonKey = ({
  id,
  dirty,
  components,
}) => {
  if (!id || dirty) return 'SmartPractice.saveLevelFirst';

  let hasLessons = false;
  let hasPractice = false;
  components.forEach(({ type }) => {
    if (type === RESOURCES.LESSON) hasLessons = true;
    if (type === RESOURCES.PRACTICE) hasPractice = true;
  });

  if (!hasLessons) return 'SmartPractice.addLessonFirst';
  if (hasPractice) return 'SmartPractice.levelHasPractice';
  return null;
};
